import Swal from 'sweetalert2';
export const toastMixin = {
  methods: {
    Toast(title, message, type, hideDismissTime = null) {
      type = type.toLowerCase();
      let toastType = '';

      switch (type) {
        case 'error':
          type = 'danger';
          toastType = 'toast-' + type;
          break;
        case 'confirm':
          this.AlertConfirm(title, message);
          break;
      }

      this.$bvToast.toast(message, {
        title: title,
        variant: type,
        noAutoHide: !hideDismissTime ? true : false,
        toastClass: toastType,
        solid: true,
        autoHideDelay: hideDismissTime,
      });
    },
    AlertConfirm: (title, message) =>
      this.$bvModal.msgBoxConfirm(message, {
        title: title,
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Si',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: true,
        centered: true,
      }),
    ShowCancelModalClosable: async (
      title,
      message,
      confirmButtonText = 'Sí',
      cancelButtonText = 'No',
      allowOutsideClick = false
    ) => {
      return Swal.fire({
        title: '',
        html: `
                    <div class="custom-cancel-popup">
                    <div class="header shadow">
                        <div class="title">
                            <div class="icon-container">
                              <i class="fas fa-bell-exclamation circle-icon"></i>
                            </div>
                            <span>${title}</span>
                        </div>
                    </div>
                    <div class="body mt-5">
                        <div class="content py-3 px-4">
                            <span >${message}</span>
                        </div>
                    </div>
                </div>
                    `,
        icon: 'warning',
        focusConfirm: false,
        focusCancel: false,
        showCancelButton: true,
        showConfirmButton: true,
        showCloseButton: true,
        allowOutsideClick,
        confirmButtonColor: '#2DB782',
        cancelButtonColor: '#D01C1C',
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        customClass: 'custom-cancel-popup',
      });
    },
  },
};
